import { Injectable } from '@angular/core';
import { IGoogleAuthWarningStorageService } from '@app/models/objects/google-auth-warning-storage.model';

const STORAGE_KEY = '2faAuthWarning';
const EXPIRE_MS = 15 * 24 * 60 * 60 * 1000; // 15 days, matching the cookie-based snooze on web

interface StoredValue {
  expiresAt: number;
}

@Injectable({ providedIn: 'root' })
export class LocalStorageGoogleAuthWarningStorageService implements IGoogleAuthWarningStorageService {
  check(): boolean {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;

    try {
      const { expiresAt }: StoredValue = JSON.parse(raw);
      if (Date.now() > expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return false;
      }
      return true;
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }
  }

  set(): void {
    const value: StoredValue = { expiresAt: Date.now() + EXPIRE_MS };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  }

  delete(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
